/**
 * @template ValueType
 */
export default class SimpleCache {
  /**
   * Structure for storing key -> value.
   * @type {Map<string|number, ValueType>}
   * @private
   */
  _map = new Map();

  /**
   * Default hashing function.
   * @param inputs {any}
   * @return {string}
   * @private
   */
  _hashFunc = (inputs) => JSON.stringify(inputs);

  /**
   * @param [hashFunc] {(any) => string|number}
   */
  constructor(hashFunc) {
    if (hashFunc) {
      this._hashFunc = hashFunc;
    }
  }

  /**
   * @param inputs {any} Cache key.
   * @param recompute {() => ValueType} Function to produce a missing value.
   * @return {ValueType}
   */
  get(inputs, recompute) {
    const key = this._hashFunc(inputs);

    if (!this._map.has(key)) {
      this._map.set(key, recompute());
    }

    return this._map.get(key);
  }
}
